import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.ITEM_ADITIVO_APOSTILA.BUSCAR_ITENS_ADITIVO_APOSTILA_LISTAGEM]({ state }) {
		const { filtro, paginacao } = state
		const { data } = await api.itensAditivoApostila.buscarListagem(filtro, paginacao)
		return data
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.BUSCAR_FORNECEDORES_ITEM_ADITIVO_APOSTILA](
		context,
		idItemAditivoApostila,
	) {
		const { data } = await api.itensAditivoApostila.buscarFornecedores(idItemAditivoApostila)
		return data
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_FORNECEDOR_ITEM_ADITIVO_APOSTILA](context, objParams) {
		const { idItemAditivoApostila, idFornecedor } = objParams
		const { data } = await api.itensAditivoApostila.alterarFornecedor(idItemAditivoApostila, idFornecedor)
		return data
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_MARCA_ITEM_ADITIVO_APOSTILA](context, objParams) {
		const { idItemAditivoApostila, marca } = objParams
		const { data } = await api.itensAditivoApostila.alterarMarca(idItemAditivoApostila, marca)
		return data
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_VALOR_ITEM_ADITIVO_APOSTILA](context, objParams) {
		const { idItemAditivoApostila, valor } = objParams
		const { data } = await api.itensAditivoApostila.alterarValor(idItemAditivoApostila, valor)
		return data
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.REMOVER_ITENS_ADITIVO_APOSTILA](context, idsItensAditivoApostila) {
		await api.itensAditivoApostila.removerItens(idsItensAditivoApostila)
	},
	async [actionTypes.ITEM_ADITIVO_APOSTILA.CANCELAR_DESCANCELAR_ITENS_ADITIVO_APOSTILA](
		{ state },
		{ idAditivoApostila, cancelado },
	) {
		const idsItensAditivoApostila = state.itensAditivoApostilaSelecionados.map((item) => item.id)
		await api.itensAditivoApostila.cancelarDescancelarItens(idAditivoApostila, idsItensAditivoApostila, cancelado)
	},
}
